module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v2_common/chat-d2938fc2c6a0ee9706173d74a1cf1a8a.svg";